var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.branchId && _vm.enabled)?_c('fakt-support-widget',{ref:"widget",attrs:{"token":_vm.token,"branch-id":_vm.branchId,"api-url":_vm.apiUrl,"ws-url":_vm.wsUrl,"quiet":_vm.quiet ? 'true' : false}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }